import type { UIMatch } from "@remix-run/react";
import type { UserData } from "~/dataType";

/**
 * Remixのmatchesからユーザー情報を取得するユーティリティ関数
 * エラーバウンダリで認証状態を取得するために使用
 */
export function getUserFromMatches(matches: UIMatch[]): UserData | null {
  // 現在のルートのデータから最初に試す
  for (const match of matches.reverse()) {
    const data = match.data as { user?: UserData } | undefined;
    if (data?.user) {
      return data.user;
    }
  }

  // rootルートのデータからフォールバック
  const rootData = matches.find(match => match.id === "root")?.data as { user?: UserData } | undefined;
  if (rootData?.user) {
    return rootData.user;
  }

  return null;
}

/**
 * エラーオブジェクトからユーザー情報を抽出する関数
 * 主に $.tsx (404ルート) のエラーレスポンスから使用
 */
export function getUserFromError(error: unknown): UserData | null {
  if (error && typeof error === 'object' && 'data' in error) {
    const errorData = error.data as { user?: UserData } | undefined;
    return errorData?.user || null;
  }
  return null;
}